import { combineReducers } from 'redux';

import category from './category';
import question from './question';

export default combineReducers({
  question,
  category,
});
